"use client"

import { GreetingComponent } from "@/components/greeting/greeting";
import { AwardIcon, ContactWidgetIcon } from "@/components/icons";
import { RepairsWidgetIcon } from "@/components/icons/RepairsWidgetIcon";
import { LargeTitle } from "@/components/typography/LargeTitle";
import {useKindeBrowserClient} from "@kinde-oss/kinde-auth-nextjs";
import { AppointmentsWidget, InsuranceWidget, MaintenanceWidget, MyBicyclesWidget, RedirectWidget } from "./_components";

export default function DashboardPage() {
  const {getUser} = useKindeBrowserClient();
  const user = getUser();

  return (
    <div className="flex flex-col">
      <LargeTitle>
        <GreetingComponent name={user?.given_name ?? ""} />
      </LargeTitle>

      <div className="flex flex-col gap-2 lg:hidden">
        <div className="flex justify-between space-x-2">
          <MobileServiceWidget
            icon={<RepairsWidgetIcon className="h-7 w-7" />}
            text="Reparatie inplannen"
            href="/reparatie-inplannen"
          />

          <MobileServiceWidget
            icon={<AwardIcon className="h-7 w-7" />}
            text="Servicebeurt inplannen"
            href="/servicebeurt-inplannen"
          />

          <MobileServiceWidget
            icon={<ContactWidgetIcon className="h-7 w-7" />}
            text="Heb je hulp nodig?"
            href="/contact"
          />
        </div>
        <AppointmentsWidget limit={2}  />

        <MaintenanceWidget limit={3} />

        <MyBicyclesWidget />

        <InsuranceWidget />
      </div>

      <div className="hidden lg:flex flex-1 justify-center items-center">
        <div className="grid grid-cols-3 grid-rows-3 gap-6 w-full">
          <AppointmentsWidget limit={4} />
          <InsuranceWidget />
          <MyBicyclesWidget />
          <MaintenanceWidget limit={4} />
          <RedirectWidget
            icon={<RepairsWidgetIcon />}
            text="Plan een reparatie"
            href="/reparatie-inplannen"
          />
          <RedirectWidget
            icon={<AwardIcon />}
            text="Plan een onderhoudsbeurt"
            href="/servicebeurt-inplannen"
          />
          <RedirectWidget
            icon={<ContactWidgetIcon />}
            text="Heb je hulp nodig?"
            href="/contact"
          />
        </div>
      </div>
    </div>
  );
}

interface WidgetProps {
  icon: React.ReactNode;
  text: string;
  href: string;
}

const MobileServiceWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  return (
    <a
      href={props.href}
      className="w-1/3 bg-white rounded-2xl text-sm flex flex-col gap-2 justify-center items-center text-center p-2 font-bold"
    >
      {props.icon}
      {props.text}
    </a>
  );
};
